const getLoginUrl = async (continueUrl: string, sacCstEnabled?: string) => {
    let loginUrl;

    if (sacCstEnabled) {
        loginUrl = `${window.ID_AUTH_URL}/login`;
        return `${loginUrl}?continue=${encodeURIComponent(continueUrl)}`;
    } else {
        loginUrl = `${window.SAC_BASE_URL}/oauth-login`;
        if (continueUrl !== undefined) {
            return `${loginUrl}?returnPage=${encodeURIComponent(continueUrl)}`;
        }
        return loginUrl;
    }
};

const getLogoutUrl = async (sacCstEnabled?: string) => {
    const continueUrl = sacCstEnabled
        ? window.SAC_BASE_URL
        : `${window.SAC_BASE_URL}/logout`;
    return `${window.LOGOUT_URL}?continue=${encodeURIComponent(continueUrl)}`;
};

export { getLoginUrl, getLogoutUrl };
